import Vue from 'vue'
import Router from 'vue-router'
var firebase = require('firebase/app')
require('firebase/auth')

Vue.use(Router)

const router =  new Router({ 
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'home',
      component: () => import('./views/Home.vue')
    },
    {
      path: '/Admin',
      name: 'admin',
      component: () => import('./views/admin.vue'),
    },
    {
      path: '/Contact-Us',
      name: 'contact',
      component: () => import('./views/Contact.vue'),
    },
    {
      path: '/CP-PipeMeIn',
      name: 'cpanel',
      component: () => import('./views/CPanel.vue'),
      meta: { requireAuth:true }
    },
    {
      path: '/Details/Product/:id',
      name: 'details',
      component: () => import('./views/Details.vue'),
    },
    {
      path: '/Gallery',
      name: 'gallery',
      component: () => import('./views/Gallery.vue'),
    },
    {
      path: '/Towers/Power&Conduit',
      name: 'powers',
      component: () => import('./components/Nueva/nuevo.vue'),
    },
    {
      path: '/Tunnels/Cable&Conduit',
      name: 'tunnels',
      component: () => import('./components/Tunnels/Tunnel.vue'),
    }
  ]
})

router.beforeEach((to, from, next) => {
  const ruteProtect = to.matched.some(record => record.meta.requireAuth);
  const user = firebase.auth().currentUser;

  if (ruteProtect === true && user === null) {
    next({name: 'home'})
  } else {
    next()
  }

})


export default router;